<div
    class="sera-audit"
    [ngClass]="styleComp">
    <div class="sera-audit__container">
        <div class="sera-audit__container__row">
            <h3 *ngIf="title">{{ title | translate }}</h3>
            <div
                *ngIf="isToShowHazardIdentification"
                class="sera-audit__container__row__cell sera-audit__container__row__cell--full">
                <span class="sera-audit__container__row__cell__title">{{ 'PAGE.ANALYSIS.MM13.TAB.DESIGNATION.LBL' | translate }}:</span>
                <span
                    [pTooltip]="hazardIdentification"
                    tooltipPosition="top"
                    class="sera-audit__container__row__cell__value"
                    >{{ hazardIdentification }}</span
                >
            </div>
            <div
                *ngIf="!isToShowHazardIdentification || isToShowHeaderDataInfo"
                class="sera-audit__container__row__cell">
                <span class="sera-audit__container__row__cell__title">{{ 'PAGE.PROBLEM.CREATOR.LBL' | translate }}:</span>
                <span
                    [pTooltip]="createdBy"
                    tooltipPosition="top"
                    class="sera-audit__container__row__cell__value"
                    >{{ createdBy ?? '-' }}</span
                >
            </div>
            <div
                *ngIf="!isToShowHazardIdentification || isToShowHeaderDataInfo"
                class="sera-audit__container__row__cell">
                <span class="sera-audit__container__row__cell__title">{{ 'PAGE.PROBLEM.ADDED.LBL' | translate }}:</span>
                <span class="sera-audit__container__row__cell__value">{{ (creationDate | date) ?? '-' }}</span>
            </div>
            <div
                *ngIf="(!isToShowHazardIdentification || isToShowHeaderDataInfo) && !hideChanged"
                class="sera-audit__container__row__cell">
                <span class="sera-audit__container__row__cell__title">{{ 'PAGE.PROBLEM.CHANGED_BY.LBL' | translate }}:</span>
                <span
                    [pTooltip]="changedBy"
                    tooltipPosition="top"
                    class="sera-audit__container__row__cell__value"
                    >{{ changedBy ?? '-' }}</span
                >
            </div>
            <div
                *ngIf="(!isToShowHazardIdentification || isToShowHeaderDataInfo) && !hideChanged"
                class="sera-audit__container__row__cell">
                <span class="sera-audit__container__row__cell__title">{{ 'PAGE.MEASURE.CHANGED_DATE.LBL' | translate }}:</span>
                <span class="sera-audit__container__row__cell__value">{{ (changedDate | date) ?? '-' }}</span>
            </div>
            <div
                *ngIf="isToShowHeaderDataInfo && !hideLastAnnual"
                class="sera-audit__container__row__cell">
                <span class="sera-audit__container__row__cell__title">{{ 'PAGE.ANALYSIS.LAST_ANNUAL_REVIEWER.LBL' | translate }}:</span>
                <span class="sera-audit__container__row__cell__value">{{ lastAnnualReviewer ?? '-' }}</span>
            </div>
            <div
                *ngIf="isToShowHeaderDataInfo && !hideLastAnnual"
                class="sera-audit__container__row__cell">
                <span class="sera-audit__container__row__cell__title">{{ 'PAGE.ANALYSIS.LAST_ANNUAL_REVIEW.LBL' | translate }}:</span>
                <span class="sera-audit__container__row__cell__value">{{ (lastAnnualReviewDate | date) ?? '-' }}</span>
            </div>
        </div>
        <div
            class="sera-audit__container__row"
            *ngIf="isToShowZeusInfo && !isToShowHazardIdentification">
            <div class="sera-audit__container__row__cell">
                <span class="sera-audit__container__row__cell__title">{{ 'PAGE.USE_CASE_CHOICE.LBL' | translate }}</span>
                <span
                    class="sera-audit__container__row__cell__value"
                    [pTooltip]="choiceWorkplaceAssessment"
                    tooltipPosition="top"
                    >{{ choiceWorkplaceAssessment }}</span
                >
            </div>
            <div class="sera-audit__container__row__cell">
                <span class="sera-audit__container__row__cell__title">{{ 'PAGE.MM_13.ZEUS_WORKPLACE_NUMBER.LBL' | translate }}</span>
                <span
                    class="sera-audit__container__row__cell__value"
                    [pTooltip]="workplaceNumbersZeus"
                    tooltipPosition="top"
                    >{{ workplaceNumbersZeus }}</span
                >
            </div>
        </div>
    </div>
</div>
